"use client";

import { Typography, Box } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { usePathname } from "next/navigation";
import { useWishlist } from "@/context/WishlistContext";
import ProductesGrid from "@/components/ProductesGrid";
import { useTexts, useText } from "@/context/TextContext";
import { useCatalogoDigitalIndice } from "@/hooks/useCatalogoDigitalIndice";
import { flattenGrupos, matchCatalogoDigitalPath } from "@/utils/catalogoDigital";
import { fetchCatalogoDigitalProductos } from "@/utils/catalogoDigitalApi";

export default function WishListSection() {
  const { wishlist, clearWishlist } = useWishlist();
  const [wishlistProducts, setWishlistProducts] = useState<any[]>([]);
  const { locale } = useTexts();
  const pathname = usePathname() || "";
  const catalogoMatch = matchCatalogoDigitalPath(pathname);
  const { catalogoGrupos } = useCatalogoDigitalIndice(pathname, locale);
  const skuToColeccion = useMemo(
    () =>
      new Map(flattenGrupos(catalogoGrupos).map((r) => [r.sku, r.coleccionNombre])),
    [catalogoGrupos]
  );

  // Cargar los productos reales desde Strapi según los SKUs
  useEffect(() => {
    const fetchWishlistProducts = async () => {
      if (wishlist.length === 0) {
        setWishlistProducts([]);
        return;
      }

      if (catalogoMatch) {
        setWishlistProducts(
          await fetchCatalogoDigitalProductos(wishlist, locale, {
            slug: catalogoMatch.catalogoSlug,
            coleccionNombrePorSku: skuToColeccion,
          })
        );
        return;
      }

      const queryParams = new URLSearchParams();

      wishlist.forEach((item, index) => {
        queryParams.append(`filters[SKU][$in][${index}]`, item.sku);
      });

      queryParams.append("populate", "*");
      queryParams.append("locale", locale);

      const res = await fetch(
        `${
          process.env.NEXT_PUBLIC_STRAPI_URL
        }/api/productos?${queryParams.toString()}`
      );

      const data = await res.json();

      // Añadimos URLs completas a las imágenes
      const productsWithFullUrls = data.data.map((p: any) => ({
        ...p,
        Imagenes: p.Imagenes?.map((img: any) => ({
          ...img,
          url: img.url?.startsWith("http")
            ? img.url
            : `${process.env.NEXT_PUBLIC_STRAPI_URL}${img.url}`,
        })),
      }));

      setWishlistProducts(productsWithFullUrls);
    };

    fetchWishlistProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wishlist, locale, catalogoMatch?.catalogoSlug, skuToColeccion]);

  const wishlistEmpty = useText("wishlist.buida");

  if (wishlist.length === 0) {
    return (
      <Typography variant="body5" color="marron">
        {wishlistEmpty}
      </Typography>
    );
  }

  return (
    <Box>
      <ProductesGrid initialProducts={wishlistProducts} />
      {/*
      <Button variant="contained" color="error" onClick={clearWishlist}>
        Vaciar wishlist
      </Button>
      */}
    </Box>
  );
}
